import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Adresse} from './adresse.model';

@Injectable()
export class AdresseService {

    private resourceUrl = 'api/adresses';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    private static empty(stringValue: String) {
        return typeof stringValue == 'undefined' || !stringValue || stringValue.length == 0;
    }

    private static clean(copy: Adresse) {
        if (AdresseService.empty(copy.pays)) {
            copy.pays = null;
        }
        if (AdresseService.empty(copy.departement)) {
            copy.departement = null;
        }
        if (AdresseService.empty(copy.ville)) {
            copy.ville = null;
        }
    }

    constructor(private http: Http) { }

    create(adresse: Adresse): Observable<Adresse> {
        let copy: Adresse = Object.assign({}, adresse);
        AdresseService.clean(copy);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }


    update(adresse: Adresse): Observable<Adresse> {
        let copy: Adresse = Object.assign({}, adresse);
        AdresseService.clean(copy);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Adresse> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/adresse/adresse.service.ts